<div [ngClass]="pageClass">
  <app-header></app-header>

  <div [ngClass]="contentClass">
    <!-- Header Section -->
    <app-asset-header [config]="headerConfig"></app-asset-header>

    <!-- Main Content -->
    <div [ngClass]="mainClass">
      <div [ngClass]="containerClass">
        <!-- Filter Sidebar (Desktop) -->
        <aside [ngClass]="sidebarClass">
      <app-asset-filter
        [config]="filterConfig"
        [searchPlaceholder]="filterSearchPlaceholder"
        [isLoggedIn]="isLoggedIn"
        (filterChange)="onFilterChange($event)"
        (resetFilters)="onResetFilters()"
        (searchChange)="onSearchChange($event)"
      ></app-asset-filter>
        </aside>

        <!-- Grid Section -->
        <main [ngClass]="gridClass">
          <app-asset-grid
            [assets]="assets"
            [assetType]="assetType"
            [searchPlaceholder]="searchPlaceholder"
            [searchQuery]="searchQuery"
            [currentPage]="currentPage"
            [totalPages]="totalPages"
            [viewMode]="viewMode"
            [itemsPerPage]="itemsPerPage"
            [showMobileFilterButton]="showMobileFilterButton"
            [isLoggedIn]="isLoggedIn"
            (pageChange)="onPageChange($event)"
            (viewModeChange)="onViewModeChange($event)"
            (searchChange)="onSearchChange($event)"
            (itemsPerPageChange)="onItemsPerPageChange($event)"
            (openMobileFilter)="onOpenMobileFilter()"
            [sortOption]="sortOption"
            (bookmarksClick)="bookmarksClick.emit()"
            (likeClick)="likeClick.emit()"
            (sortChange)="onSortChange($event)"
          ></app-asset-grid>
        </main>
      </div>
    </div>
  </div>

  <!-- Optional bottom section (e.g. Contact Us form on Models page) -->
  <ng-content select="[bottomSection]"></ng-content>

  <app-footer></app-footer>

  <!-- Mobile Filter Modal -->
  <div [ngClass]="mobileFilterOverlayClass" 
       [class.active]="isMobileFilterOpen"
       (click)="onCloseMobileFilter()">
  </div>
  <div [ngClass]="mobileFilterModalClass" 
       [class.active]="isMobileFilterOpen">
    <div [ngClass]="mobileFilterHeaderClass">
      <h2 [ngClass]="mobileFilterTitleClass">{{ mobileFilterTitle }}</h2>
      <button [ngClass]="mobileFilterCloseClass" 
              (click)="onCloseMobileFilter()"
              aria-label="Close filters">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    <div [ngClass]="mobileFilterContentClass">
      <app-asset-filter
        [config]="filterConfig"
        [searchPlaceholder]="filterSearchPlaceholder"
        [isLoggedIn]="isLoggedIn"
        (filterChange)="onFilterChange($event)"
        (resetFilters)="onResetFilters()"
        (searchChange)="onSearchChange($event)"
      ></app-asset-filter>
    </div>
    <div [ngClass]="mobileFilterFooterClass">
      <button [ngClass]="mobileFilterResetClass" 
              (click)="onResetFilters()"
              *ngIf="filterConfig.activeFilterCount > 0">
        Reset
      </button>
      <button [ngClass]="mobileFilterApplyClass" 
              (click)="onCloseMobileFilter()">
        Apply Filter ({{ filterConfig.activeFilterCount }})
      </button>
    </div>
  </div>
</div>
